import axios from "axios";
import environment from "@/environment";
const api = axios.create({ baseURL: `${environment.API}/modules`});

const MODULE_MAP = {
	MMI: "Comum",
	OEE: "Oee",
	Alarmes: "Alarmes",
	Mapas: "Mapas",
	ARMP: "Armp"
};

let modulesURLCache = null;
async function loadModules () {
	if (modulesURLCache) return modulesURLCache;

	try {
		const response = await api.get("/", {
			params: { includeNoFront: true }
		});
		modulesURLCache = response.data || [];
		return modulesURLCache;
	} catch {
		modulesURLCache = null;
		return [];
	}
}

async function getModuleURL (moduleName) {
	const modules = await loadModules();
	return modules.find(m => m.nome === moduleName)?.url ?? null;
}

async function checkTimestamp (moduleName) {
	const url = await getModuleURL(moduleName);
	if (!url)
		throw new Error(`URL do módulo "${moduleName}" não encontrada`);

	return axios.get(`${url}/api/v1/timestamp`);
}

export async function getModulesURL () {
	try {
		const data = await loadModules();
		return { data, error: data.length === 0 ? "Nenhum módulo encontrado" : null };
	} catch {
		return { data: [], error: "Erro ao buscar módulos" };
	}
}

export async function fetchTimestamp (moduleName) {
	const start = performance.now();
	try {
		const response = await checkTimestamp(moduleName);
		return {
			...response.data,
			statusCode: response.status,
			timestamp: response.data.timestamp,
			requestTime: Math.round(performance.now() - start)
		};
	} catch (error) {
		const isNetworkOrCors = error.request && !error.response;
		return {
			moduleName,
			statusCode: error.response?.status ?? (isNetworkOrCors ? 503 : 500),
			timestamp: error.response?.data?.timestamp ?? null,
			requestTime: Math.round(performance.now() - start)
		};
	}
}

export async function FetchTimestampDashboard () {
	const results = await Promise.allSettled(
		Object.entries(MODULE_MAP).map(([name, moduleName]) => fetchTimestamp(moduleName))
	);

	const online = [];
	const offline = [];

	Object.keys(MODULE_MAP).forEach((name, index) => {
		const result = results[index];
		const isError = result.value.statusCode !== 200;

		if (!isError) {
			online.push({ service: name, data: result.value });
		} else {
			offline.push({
				service: name,
				error: result.reason?.response?.data
				?? (result.reason?.request ? "Serviço inacessível (rede/CORS)" : "Erro desconhecido")
			});
		}
	});

	return {
		statusCode: offline.length > 0 ? 418 : 200,
		online,
		offline
	};
}

export const FetchMmiTimestamp = () => fetchTimestamp(MODULE_MAP.MMI);
export const FetchOeeTimestamp = () => fetchTimestamp(MODULE_MAP.OEE);
export const FetchAlarmesTimestamp = () => fetchTimestamp(MODULE_MAP.Alarmes);
export const FetchMapasTimestamp = () => fetchTimestamp(MODULE_MAP.Mapas);
export const FetchArmpTimestamp = () => fetchTimestamp(MODULE_MAP.ARMP);
